// extracted by mini-css-extract-plugin
export default {"root":"QuickAccessButton_root__J43xe","visible":"QuickAccessButton_visible__y3uCs"};